import { Text, View } from '@react-pdf/renderer';

import { financingContingencyText } from '@/utils/financingClause';
import { Contract } from '@/types/ContractType';
import { styles } from '../style';

/** Mirrors the on-screen Mortgage Financing clause word for word. */
const MortgageFinancing = ({ contract }: { contract: Contract }) => {
  const offer = contract?.offerSpecifics;
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Mortgage Financing</Text>

      <Text style={styles.text}>
        1.{' '}
        {financingContingencyText({
          contingency: contract?.contingency?.financingContingency,
          contingencyType: contract?.contingency?.financingContingencyType,
          commitmentDate: offer?.financingCommittmentDate,
        })}
      </Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>a. Proposed First Mortgage</Text>

        <View style={styles.subList}>
          <Text style={styles.listItem}>
            i. The loan program selected for this purchase is{' '}
            <Text style={styles.ClauseText}>{offer?.financingLoanProgram}</Text>
            .
          </Text>
          <Text style={styles.listItem}>
            ii. The loan amount is{' '}
            <Text style={styles.ClauseText}>{offer?.loanAmount}</Text>.
          </Text>
          <Text style={styles.listItem}>
            iii. The loan term is{' '}
            <Text style={styles.ClauseText}>{offer?.loanTerm} years</Text>.
          </Text>
          <Text style={styles.listItem}>
            iv. The market interest rate is{' '}
            <Text style={styles.ClauseText}>{offer?.marketInterestRate}%</Text>.
          </Text>
          <Text style={styles.listItem}>
            v. The lender for this transaction is{' '}
            <Text style={styles.ClauseText}>{offer?.lenderName}</Text>.
          </Text>
          <Text style={styles.listItem}>
            vi. The lender address is{' '}
            <Text style={styles.ClauseText}>{offer?.lenderAddress}</Text>.
          </Text>
          <Text style={styles.listItem}>
            vii. The lender NMLS ID is{' '}
            <Text style={styles.ClauseText}>{offer?.lenderNMLS}</Text>
          </Text>
          <Text style={styles.listItem}>
            viii. The loan officer for this transaction is{' '}
            <Text style={styles.ClauseText}>{offer?.loanOfficerName}</Text>
          </Text>
          <Text style={styles.listItem}>
            ix. The loan officer phone number is{' '}
            <Text style={styles.ClauseText}>{offer?.loanOfficerPhone}</Text>
          </Text>
          <Text style={styles.listItem}>
            x. The loan officer email is{' '}
            <Text style={styles.ClauseText}>{offer?.loanOfficerEmail}</Text>
          </Text>
          <Text style={styles.listItem}>
            xi. The loan officer NMLS ID is{' '}
            <Text style={styles.ClauseText}>{offer?.loanOfficerNMLS}</Text>
          </Text>
          <Text style={styles.listItem}>
            xii. The Pre-Approval Letter is attached to this contract.
          </Text>
        </View>
      </View>
    </View>
  );
};

export default MortgageFinancing;
